import { NextRouter } from 'next/router';
import { deleteManyQuery, deleteQuery, localStorage } from '../utils';
import cookie from './cookie';

const leadDataParamsKeys = {
  utm_content: 'utmContent',
  utm_campaign: 'utmCampaign',
  utm_source: 'utmSource',
  utm_term: 'utmTerm',
  gclid: 'gclid',
  fbclid: 'fbclid',
  _fbc: '_fbc',
};

const saveLeadParams = (router: NextRouter, shouldDeleteUtm: boolean = true) => {
  const { ssgParams, ...rest } = router.query;
  const leadParamsToSave = { ...leadDataParamsKeys, quiz: 'quiz' };

  const queries = Object.entries(rest).filter(([key]) => key in leadParamsToSave);

  if (typeof window !== 'undefined' && queries?.length) {
    queries.forEach(([key, value]) => {
      if (key === leadDataParamsKeys.fbclid) {
        const fbcValue = cookie.getCookie(leadDataParamsKeys._fbc);
        const existedFbclid = localStorage.getItem(key);

        if (existedFbclid !== value || !fbcValue) {
          const fbc = `fb.1.${Date.now().toString()}.${value}`;

          localStorage.setItem(leadDataParamsKeys._fbc, fbc);
          cookie.setCookie(leadDataParamsKeys._fbc, fbc, 90);
        }
      }

      if (key === leadDataParamsKeys._fbc) {
        cookie.setCookie(leadDataParamsKeys._fbc, value as string, 90);
      }

      localStorage.setItem(key, value as string);
    });

    if (shouldDeleteUtm) {
      deleteManyQuery(
        router,
        queries.map(([key]) => key),
      );
      return;
    }
    if (router?.query?.quiz) deleteQuery(router, 'quiz');
  }
};

const getLeadData = (withQuiz = false) => {
  let leadData: Record<string, string | null> = {};

  Object.entries(leadDataParamsKeys).forEach(([key, name]) => {
    const param = localStorage.getItem(key);
    if (param) leadData[name] = param;
  });

  const quiz = localStorage.getItem('quiz');

  if (quiz && withQuiz) {
    const parsedData = JSON.parse(quiz);

    const crmPlatforms = parsedData?.crmPlatforms || [];
    const otherCrmPlatforms = parsedData?.otherCrmPlatforms || '';

    const reviewPlatforms = parsedData?.reviewPlatforms || [];
    const otherReviewPlatforms = parsedData?.otherReviewPlatforms || '';

    const otherInterestedSolutions = parsedData?.otherInterestedSolutions || '';
    const interestedSolutions = parsedData?.interestedSolutions || [];
    
    leadData = {
      ...leadData,
      integrations: [...crmPlatforms, otherCrmPlatforms].join(','),
      locationsCount: parsedData?.locationsCount,
      reviewPlatforms: [...reviewPlatforms, otherReviewPlatforms].join(','),
      monthlyCustomers: parsedData?.monthlyCustomers,
      reviewManagers: parsedData?.otherReviewManagers,
      interestedSolutions: [...interestedSolutions, otherInterestedSolutions].join(','),
    };
  }

  const dataWithoutEmptyValues = Object.fromEntries(
    Object.entries(leadData).filter(
      ([_key, value]) => value !== undefined && value !== null && value !== '',
    ),
  );

  return dataWithoutEmptyValues;
};

export { leadDataParamsKeys, getLeadData, saveLeadParams };
